
// add class for specific pages to achieve fullscreen, custom background etc.
export default function CustomPageDirective() {
    
    return {
        restrict: 'A',
        controller: CustomPageController
    };

    function CustomPageController($scope, $element, $location) {

        'ngInject';
        
        const path = function() {
            return $location.path();
        };

        const addBg = function(path) {
            $element.removeClass('body-wide body-err body-lock body-auth');
            switch (path) {
                case '/404':
                case '/pages/404':
                case '/500':
                    return $element.addClass('body-wide body-err');
                case '/pages/signin':
                case '/emailVerification':
                case '/pages/signup':
                case '/pages/forgot-password':
                    return $element.addClass('body-wide body-auth');
                case '/pages/lock-screen':
                    return $element.addClass('body-wide body-lock');
            }
        };

        addBg(path());

        $scope.$watch(path, function(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            return addBg(path());
        });
    }
}
